/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectIntegrationRuntimeStatus
 */
export interface ProjectIntegrationRuntimeStatus {
    /**
     * 
     * @type {string}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    integrationId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    integrationName?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    accountName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    ready?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    phase?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    updateModel?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    bootstrapPending?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    lastSuccessfulFetchAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    nextScheduledFetchAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    nextScheduledFetchMode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    activeRunId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    activeRunMode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    activeFetchMode?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    canManualRefresh?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProjectIntegrationRuntimeStatus
     */
    error?: string | null;
}

/**
 * Check if a given object implements the ProjectIntegrationRuntimeStatus interface.
 */
export function instanceOfProjectIntegrationRuntimeStatus(value: object): value is ProjectIntegrationRuntimeStatus {
    return true;
}

export function ProjectIntegrationRuntimeStatusFromJSON(json: any): ProjectIntegrationRuntimeStatus {
    return ProjectIntegrationRuntimeStatusFromJSONTyped(json, false);
}

export function ProjectIntegrationRuntimeStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectIntegrationRuntimeStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'integrationId': json['integrationId'] == null ? undefined : json['integrationId'],
        'integrationName': json['integrationName'] == null ? undefined : json['integrationName'],
        'accountName': json['accountName'] == null ? undefined : json['accountName'],
        'ready': json['ready'] == null ? undefined : json['ready'],
        'status': json['status'] == null ? undefined : json['status'],
        'phase': json['phase'] == null ? undefined : json['phase'],
        'updateModel': json['updateModel'] == null ? undefined : json['updateModel'],
        'bootstrapPending': json['bootstrapPending'] == null ? undefined : json['bootstrapPending'],
        'lastSuccessfulFetchAt': json['lastSuccessfulFetchAt'] == null ? undefined : json['lastSuccessfulFetchAt'],
        'nextScheduledFetchAt': json['nextScheduledFetchAt'] == null ? undefined : json['nextScheduledFetchAt'],
        'nextScheduledFetchMode': json['nextScheduledFetchMode'] == null ? undefined : json['nextScheduledFetchMode'],
        'activeRunId': json['activeRunId'] == null ? undefined : json['activeRunId'],
        'activeRunMode': json['activeRunMode'] == null ? undefined : json['activeRunMode'],
        'activeFetchMode': json['activeFetchMode'] == null ? undefined : json['activeFetchMode'],
        'canManualRefresh': json['canManualRefresh'] == null ? undefined : json['canManualRefresh'],
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function ProjectIntegrationRuntimeStatusToJSON(json: any): ProjectIntegrationRuntimeStatus {
    return ProjectIntegrationRuntimeStatusToJSONTyped(json, false);
}

export function ProjectIntegrationRuntimeStatusToJSONTyped(value?: ProjectIntegrationRuntimeStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'integrationId': value['integrationId'],
        'integrationName': value['integrationName'],
        'accountName': value['accountName'],
        'ready': value['ready'],
        'status': value['status'],
        'phase': value['phase'],
        'updateModel': value['updateModel'],
        'bootstrapPending': value['bootstrapPending'],
        'lastSuccessfulFetchAt': value['lastSuccessfulFetchAt'],
        'nextScheduledFetchAt': value['nextScheduledFetchAt'],
        'nextScheduledFetchMode': value['nextScheduledFetchMode'],
        'activeRunId': value['activeRunId'],
        'activeRunMode': value['activeRunMode'],
        'activeFetchMode': value['activeFetchMode'],
        'canManualRefresh': value['canManualRefresh'],
        'error': value['error'],
    };
}

